export type AIIconProps = {
  width?: number;
  height?: number;
  className?: string;
  title?: string;
};

export const AIIcon = ({
  width,
  height,
  className,
  title = "Ícone IA",
}: AIIconProps) => {
  const id = "icon-ai-linear-gradient";
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? 18}
      height={height ?? 18}
      viewBox="0 0 18 18"
      fill="none"
    >
      <title>{title}</title>
      <path
        d="M6.58917 3.54008C7.0875 2.08175 9.1025 2.03758 9.69334 3.40758L9.74334 3.54091L10.4158 5.50758C10.57 5.95861 10.819 6.37134 11.1462 6.71793C11.4734 7.06453 11.8711 7.33692 12.3125 7.51675L12.4933 7.58425L14.46 8.25591C15.9183 8.75425 15.9625 10.7692 14.5933 11.3601L14.46 11.4101L12.4933 12.0826C12.0422 12.2366 11.6293 12.4856 11.2825 12.8128C10.9358 13.14 10.6633 13.5378 10.4833 13.9792L10.4158 14.1592L9.74417 16.1267C9.24584 17.5851 7.23084 17.6292 6.64084 16.2601L6.58917 16.1267L5.9175 14.1601C5.76349 13.7089 5.51448 13.296 5.18729 12.9493C4.8601 12.6025 4.46233 12.33 4.02084 12.1501L3.84084 12.0826L1.87417 11.4109C0.415003 10.9126 0.370836 8.89758 1.74084 8.30758L1.87417 8.25591L3.84084 7.58425C4.29186 7.43013 4.7046 7.18108 5.05119 6.85389C5.39778 6.5267 5.67018 6.12899 5.85 5.68758L5.9175 5.50758L6.58917 3.54008ZM14.8333 0.666748C14.9892 0.666748 15.142 0.71048 15.2743 0.792974C15.4066 0.875469 15.5131 0.993417 15.5817 1.13341L15.6217 1.23091L15.9133 2.08591L16.7692 2.37758C16.9254 2.43066 17.0624 2.52893 17.1627 2.65993C17.263 2.79093 17.3222 2.94876 17.3327 3.11343C17.3433 3.2781 17.3047 3.44219 17.2219 3.5849C17.139 3.72762 17.0157 3.84253 16.8675 3.91508L16.7692 3.95508L15.9142 4.24675L15.6225 5.10258C15.5693 5.25877 15.471 5.39566 15.3399 5.49591C15.2089 5.59615 15.051 5.65524 14.8864 5.66568C14.7217 5.67612 14.5577 5.63745 14.415 5.55456C14.2723 5.47168 14.1575 5.3483 14.085 5.20008L14.045 5.10258L13.7533 4.24758L12.8975 3.95591C12.7413 3.90284 12.6043 3.80457 12.504 3.67357C12.4037 3.54257 12.3445 3.38473 12.3339 3.22006C12.3234 3.05539 12.362 2.89131 12.4448 2.74859C12.5276 2.60588 12.651 2.49097 12.7992 2.41841L12.8975 2.37841L13.7525 2.08675L14.0442 1.23091C14.1004 1.06627 14.2067 0.923339 14.3482 0.822164C14.4897 0.720989 14.6594 0.666644 14.8333 0.666748Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient
          id={id}
          x1="0.249992"
          y1="10.2501"
          x2="17.75"
          y2="10.2501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5858BF" />
          <stop offset="1" stopColor="#E22446" />
        </linearGradient>
      </defs>
    </svg>
  );
};
